export const GET_ALL_DEVICE_LIST = "V1_GET_ALL_DEVICE_LIST";
export const GET_DEVICE_LATEST = "V1_GET_DEVICE_LATEST";
